import React from "react"

const Badge = React.forwardRef(({ 
  className = "", 
  variant = "default", 
  children, 
  ...props 
}, ref) => {
  const getVariantClasses = () => {
    switch (variant) {
      case "default":
        return "border-transparent bg-blue-600 text-white hover:bg-blue-700"
      case "secondary":
        return "border-transparent bg-gray-100 text-gray-700 hover:bg-gray-200"
      case "destructive":
        return "border-transparent bg-red-100 text-red-700 hover:bg-red-200"
      case "outline":
        return "border border-gray-300 bg-transparent text-gray-900"
      case "orange":
        return "border-transparent bg-orange-100 text-orange-800 hover:bg-orange-200"
      default:
        return "border-transparent bg-blue-600 text-white hover:bg-blue-700"
    }
  }

  return (
    <div
      ref={ref}
      className={`
        ${className}
        inline-flex items-center rounded-lg border px-2.5 py-0.5 text-xs font-semibold 
        transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
      
      `}
      {...props}
    >
      {children}
    </div>
  )
})

Badge.displayName = "Badge"

export { Badge } 